export enum ReportProblemSpace {
  APARTMENT = 'apartment',
  BUILDING = 'building',
  SURROUNDINGS = 'surroundings',
  COMMON_AREAS = 'common-areas',
  OTHER = 'other',
}
